module.exports = __webpack_public_path__ + "resources/img/obbject-2-x@3x.0ff260fb.png";